<template>
  <span class="p-datePicker-wrapper">
    <label class="p-datePicker-label" v-if="internalValue && label">
      {{ placeholder }}
      <span class="p-label__star" v-if="isRequired"> (الزامی) </span>
    </label>
    <p-date-picker
      ref="picker"
      color="#edb022"
      :popover="popover"
      v-model="internalValue"
      :class="wrapperClass"
      :input-class="inputClass"
      :type="type"
      :auto-submit="autoSubmit"
      :editable="true"
      :inline="inline"
      :multiple="multiple"
      :disabled="disabled"
      :min="min"
      :max="max"
      :initial-value="initialCalendar"
      :placeholder="isRequired ? placeholder + ' (الزامی)' : placeholder"
      :display-format="
        type == 'date'
          ? dateType == 2
            ? 'YYYY/MM/DD'
            : 'jYYYY/jMM/jDD'
          : type == 'time'
          ? 'HH:mm'
          : type == 'datetime'
          ? dateType == 2
            ? 'YYYY/MM/DD HH:mm'
            : 'jYYYY/jMM/jDD HH:mm'
          : ''
      "
      :format="
        type == 'date'
          ? 'YYYY/MM/DD'
          : type == 'time'
          ? 'HH:mm'
          : type == 'datetime'
          ? 'YYYY/MM/DD HH:mm'
          : ''
      "
      :locale="dateType == 2 ? 'en' : 'fa'"
      @input="updateDateValue"
    >
      <div slot="label" class="mt-1">
        <i :class="icon"></i>
      </div>
    </p-date-picker>
  </span>

  <!-- :format="type == 'date' ? 'jYYYY/jMM/jDD' : ''" shamsi -->
  <!-- :format="type == 'date' ? 'YYYY/MM/DD' : ''" miladi -->
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/plugins/eventBus.js";
import moment from "moment-jalaali";
const nowDate = moment().format("YYYY/MM/DD");
const startMonth = moment().startOf("jMonth").format("YYYY/MM/DD");
const endMonth = moment().endOf("jMonth").format("YYYY/MM/DD");
const lastMonth = moment().subtract(1, "Month").format("YYYY/MM/DD");
const lastYear = moment().subtract(1, "Year").format("YYYY/MM/DD");
const sevenDaysLater = moment().add(7, "days").format("YYYY/MM/DD");

function normalizeDate(date) {
  if (!date) return null;
  if (Array.isArray(date)) {
    return date.map((item) => normalizeDate(item));
  }
  if (typeof date === "string") {
    if (date.includes("T")) {
      return date.split("T")[0].replace(/-/g, "/");
    }
    return date;
  }
  return moment(date).format("YYYY/MM/DD");
}

// مقداری که بعد از mount از والد می‌رسد معمولاً مستقیم از پاسخ API است و قالب
// ISO دارد ("2026-09-05T00:00:00")؛ p-date-picker آن را نمی‌شناسد و فیلد خالی
// نمایش داده می‌شود. فقط همین حالت تبدیل می‌شود و هر مقدار دیگری بی‌دست‌کاری
// عبور می‌کند تا رفتار پیکرهای time و ورودی‌های خالی/Date عوض نشود.
function normalizeIncoming(value, type) {
  if (type !== "date") return value;
  if (Array.isArray(value)) {
    return value.map((item) => normalizeIncoming(item, type));
  }
  if (typeof value === "string" && value.includes("T")) {
    return normalizeDate(value);
  }
  return value;
}

export default {
  name: "DatePicker",
  props: {
    value: {
      // type: String,
      default: null,
    },
    modelValue: {
      // type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: Boolean,
      default: true,
    },
    wrapperClass: {
      type: String,
      default: "p-datePicker",
    },
    inputClass: {
      type: String,
      default: "p-datePicker-input",
    },
    type: {
      type: String,
      default: "date",
    },
    icon: {
      type: String,
      default: "pi pi-calendar text-p-muted-light",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultDate: {
      type: String,
      default: "",
    },
    storageName: {
      type: String,
      required: null,
    },
    // پیش‌فرض‌هایی مثل nowDate/startMonth نسبت به تاریخ روز حساب می‌شوند و در
    // سال مالی گذشته بیرون از بازه می‌افتند. اگر این prop مقدار "start" یا "end"
    // بگیرد، تاریخ پیش‌فرضِ خارج از بازه به همان لبه‌ی سال مالی snap می‌شود.
    // فقط روی فیلترها استفاده شود، نه روی تاریخِ سندی که کاربر ثبت می‌کند.
    fiscalRange: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    popover: {
      type: Boolean,
      default: true,
    },
    initialCalendar: {
      type: String,
    },
    autoSubmit: {
      type: Boolean,
      default: false,
    },
    // فقط برای type="time": ارقام تایپ‌شده همان لحظه به قالب HH:mm درمی‌آیند
    // (مثلاً 1208 → 12:08).
    timeMask: {
      type: Boolean,
      default: false,
    },
    // کف و سقف تاریخ قابل انتخاب، با همان قالب مقدار (میلادی YYYY/MM/DD).
    // اگر ست نشود هیچ محدودیتی اعمال نمی‌شود.
    min: {
      type: String,
      default: undefined,
    },
    max: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      // internalValue: this.value != null ? this.value : this.modelValue,
      internalValue: this.multiple
        ? this.value || this.modelValue || []
        : this.value != null
        ? this.value
        : this.modelValue,
      isInitialValueSet: false,
      dateType: Number(JSON.parse(localStorage.getItem("DateType"))),
    };
  },
  computed: {
    ...mapGetters({
      profile: "userProfile",
      fiscalYear: "dropdownX/fiscalYearById",
    }),
  },
  watch: {
    storageName() {
      if (this.storageName) {
        const storedDate = this.readStoredValue();
        if (storedDate) {
          this.internalValue = normalizeDate(storedDate);
          this.$emit("update:modelValue", this.internalValue);
        } else {
          this.internalValue = this.multiple ? [] : null;
          this.isInitialValueSet = false;
          this.updateDateValue();
        }
      }
    },
    // profile() {
    //   if (this.profile) {
    //     this.dateType = this.profile.dateType;
    //     if (this.storageName) {
    //       const storedDate = JSON.parse(localStorage.getItem(this.storageName));
    //       if (storedDate) {
    //         this.internalValue = storedDate;
    //       }
    //       this.$emit("update:modelValue", this.internalValue);
    //     }
    //   }
    // },
    modelValue(newVal) {
      this.internalValue = normalizeIncoming(
        this.multiple ? newVal || [] : newVal,
        this.type,
      );
    },
    value(newVal) {
      this.internalValue = normalizeIncoming(
        this.multiple ? newVal || [] : newVal,
        this.type,
      );
    },
    fiscalYear() {
      if (this.fiscalYear) {
        this.isInitialValueSet = false;
        this.updateDateValue();
      }
    },
    internalDate(newVal) {
      if (newVal) {
        const formatted = new Date(newVal)
          .toISOString()
          .split("T")[0]
          .replace(/-/g, "/");
        this.$emit("update:modelValue", formatted);
      }
    },
  },
  methods: {
    maskTimeInput(e) {
      const digits = e.target.value
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/\D/g, "")
        .slice(0, 4);
      e.target.value =
        digits.length > 2 ? digits.slice(0, 2) + ":" + digits.slice(2) : digits;
    },
    readStoredValue() {
      const raw = localStorage.getItem(this.storageName);
      if (!raw) return null;
      try {
        return JSON.parse(raw);
      } catch (e) {
        // سازگاری با مقادیری که بدون JSON.stringify ذخیره شده‌اند
        return raw;
      }
    },
    // اگر تاریخ داخل بازه‌ی سال مالی باشد دست‌نخورده برمی‌گردد؛ در غیر این صورت
    // به ابتدای بازه (fiscalRange="start") یا انتهای آن (fiscalRange="end")
    // snap می‌شود تا فیلتر همیشه داخل سال مالی انتخابی بماند.
    applyFiscalRange(date) {
      let start = localStorage.getItem("startYear");
      let end = localStorage.getItem("endYear");
      if (!start || !end) return date;
      try {
        start = JSON.parse(start);
        end = JSON.parse(end);
      } catch (e) {
        return date;
      }
      const from = normalizeDate(start);
      const to = normalizeDate(end);
      if (!from || !to) return date;
      const current = normalizeDate(date);
      if (current && current >= from && current <= to) return date;
      return this.fiscalRange === "end" ? to : from;
    },
    updateDateValue(value) {
      let newValue = value || this.internalValue;
      this.internalValue = normalizeDate(newValue);
      if (!this.isInitialValueSet) {
        let isEmpty = this.multiple
          ? !this.internalValue.length
          : !this.internalValue;
    
        if (isEmpty && this.storageName) {
          const stored = this.readStoredValue();
          if (stored) {
            this.internalValue = normalizeDate(stored);
            isEmpty = false;
          }
        }
        if (isEmpty && this.defaultDate === "nowDate") {
          this.internalValue = normalizeDate(nowDate);
        } else if (isEmpty && this.defaultDate === "startYear") {
          this.internalValue = normalizeDate(
            JSON.parse(localStorage.getItem("startYear")),
          );
        } else if (isEmpty && this.defaultDate === "endYear") {
          this.internalValue = normalizeDate(
            JSON.parse(localStorage.getItem("endYear")),
          );
        } else if (isEmpty && this.defaultDate === "startMonth") {
          this.internalValue = normalizeDate(startMonth);
        } else if (isEmpty && this.defaultDate === "endMonth") {
          this.internalValue = normalizeDate(endMonth);
        } else if (isEmpty && this.defaultDate === "lastMonth") {
          this.internalValue = normalizeDate(lastMonth);
        } else if (isEmpty && this.defaultDate === "lastYear") {
          this.internalValue = normalizeDate(lastYear);
        } else if (isEmpty && this.defaultDate === "sevenDaysLater") {
          this.internalValue = normalizeDate(sevenDaysLater);
        }
    
        if (isEmpty && this.fiscalRange && !this.multiple) {
          this.internalValue = this.applyFiscalRange(this.internalValue);
        }
        this.isInitialValueSet = true;
      }
      this.$emit("update:modelValue", this.internalValue);
      if (this.storageName) {
        localStorage.setItem(
          this.storageName,
          JSON.stringify(this.internalValue),
        );
      }
    },
  },
  mounted() {
    const timeInput =
      this.timeMask && this.type == "time" && this.$refs.picker?.$refs.input;
    if (timeInput) {
      timeInput.setAttribute("maxlength", "5");
      timeInput.setAttribute("inputmode", "numeric");
      timeInput.setAttribute("dir", "ltr");
      timeInput.addEventListener("input", this.maskTimeInput);
    }
    if (
      this.$route.name != "PPARSINAAddCompany" &&
      this.$route.name != "PPARSINAEditCompany"
    ) {
      // this.$store.dispatch("getCurrentUser");
      this.updateDateValue();
    }
    localStorage.setItem("nowDate", JSON.stringify(nowDate));
    localStorage.setItem("startMonth", JSON.stringify(startMonth));
    localStorage.setItem("endMonth", JSON.stringify(endMonth));
    localStorage.setItem("lastMonth", JSON.stringify(lastMonth));
    localStorage.setItem("lastYear", JSON.stringify(lastYear));
    localStorage.setItem("sevenDaysLater", JSON.stringify(sevenDaysLater));

    EventBus.$on("default-modal-date", (payload) => {
      this.isInitialValueSet = false;
   
      if (!payload && (this.defaultDate || this.storageName)) {
        this.internalValue = this.multiple ? [] : null;
      }
      this.updateDateValue(payload);
    });
  },
};
</script>
